const nippleDischarge = [

    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left", ]
    },

 
    {label:"Colour",
    controlType:"radio button",
    options:["Clear", "White/ yellow", "Green", "Brown","Blood" ]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default nippleDischarge